// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1hUGd","Success":"Button_Success__1K5CB","Danger":"Button_Danger__2LBP_","OrderButton":"Button_OrderButton__NHcZl","Primary":"Button_Primary__1pkUc"};